import { combineReducers } from 'redux'

// import aut

import technologyBrowserState from './technologies/reducer'
import issuesState from './issues/reducer'

// import reducers

const rootReducer = combineReducers({
    technologyBrowserState: technologyBrowserState,
    issues: issuesState,
})

export default rootReducer
